import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BugReportInput, SystemStatusReport } from '@cpd-app/generated';

@Component({
  selector: 'cpd-report-issue',
  templateUrl: './report-issue.component.html',
  styleUrls: ['./report-issue.component.scss']
})
export class ReportIssueComponent {
  @Input() public systemReports: SystemStatusReport[] = [];

  @Output() public closeDialog = new EventEmitter<void>();
  @Output() public report = new EventEmitter<BugReportInput>();

  public comments = new FormControl('', [
    Validators.required,
    Validators.maxLength(4000)
  ]);

  constructor(private router: Router) {}

  public reportIssue(): void {
    if (this.comments.valid) {
      this.report.emit({
        message: this.comments.value,
        buglocation: this.router.url
      });
    }
  }
}
